export { Switch as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/Switch.js
// module id = 1195
// module chunks = 0